






































































































































































































import { Component, Vue, Prop } from 'nuxt-property-decorator'
import ImagesGallery from '~/components/shared/imagesGallery.vue'
import VirtualTourWrapper from '~/components/shared/VirtualTourWrapper.vue'
import ImageGalleryWrapper from '~/components/shared/ImageGalleryWrapper.vue'
import VideoGalleryWrapper from '~/components/shared/VideoGalleryWrapper.vue'
import {
  streetViewMetadata,
  EMBED_BASE_URL,
  STREET_VIEW,
} from '~/api/gmaps.api'

@Component({
  components: {
    ImagesGallery,
    VirtualTourWrapper,
    ImageGalleryWrapper,
    VideoGalleryWrapper,
  },
})
export default class RichTooltipPoi extends Vue {
  @Prop({ default: {} }) data: any

  showVirtualTour: boolean = false
  showImageGallery: boolean = false
  showVideoGallery: boolean = false
  activeTab: number = 0
  streetViewMeta = { status: 'ZERO_RESULTS' }
  latitude: number = 0
  longitude: number = 0
  images: string[] = []

  mounted() {
    this.latitude = this.data.latitude
    this.longitude = this.data.longitude
    this.images = this.getImages()
    this.getStreetViewMetadata({
      latitude: this.latitude,
      longitude: this.longitude,
    })
  }

  closeTooltip() {
    this.$nuxt.$emit('closePopup')
  }

  private async getStreetViewMetadata({
    latitude,
    longitude,
  }: {
    latitude: number
    longitude: number
  }) {
    this.streetViewMeta = await streetViewMetadata(
      latitude,
      longitude,
      process.env.mapApiKey
    )
  }

  getImages() {
    if (this.data?.images.length) {
      return this.data?.images.map((image: any) => image.url) || []
    } else if (this.data?.heroImage.length) {
      return this.data?.heroImage
    } else if (this.data?.thumbnail) {
      return [this.data?.thumbnail]
    } else return []
  }

  get virtualTour() {
    return this.data?.virtualTourUrl
  }

  get gStreetMapUrl(): string {
    return `${EMBED_BASE_URL}${STREET_VIEW}?key=${process.env.mapApiKey}&location=${this.latitude},${this.longitude}&heading=236`
  }

  get videos(): string {
    return this.data?.videos || []
  }

  setShowVirtualTour(value: boolean): void {
    this.showVirtualTour = value
    this.onShowView(value)
  }

  setShowImageGallery(value: boolean): void {
    this.showImageGallery = value
    this.onShowView(value)
  }

  setShowVideoGallery(value: boolean): void {
    this.showVideoGallery = value
    this.onShowView(value)
  }

  onShowView(value: boolean) {
    // this will notify to the map that the rich tooltip will be showed in full view
    this.$nuxt.$emit('richTooltipPoi:onShowView', value)
  }
}
